import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { StatusBadge, CompanyAvatar } from "@/components/StatusBadge";
import { BOLAG, FASER } from "@/lib/portfolio-data";

export const Route = createFileRoute("/sammanstallning")({
  head: () => ({
    meta: [
      { title: "Bolagssammanställning — Inkubera" },
      {
        name: "description",
        content:
          "Komplett lista över Inkuberas bolag och innovationer med bransch och kort beskrivning.",
      },
    ],
  }),
  component: Sammanstallning,
});

function Sammanstallning() {
  // Gruppera per fas, men hoppa över faser utan bolag
  const grupper = FASER
    .map((f) => ({ fas: f, bolag: BOLAG.filter((b) => b.fas === f) }))
    .filter((g) => g.bolag.length > 0);

  return (
    <AppShell>
      <section className="px-8 pt-10 pb-6 border-b border-border">
        <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground mb-2">
          Sammanställning
        </div>
        <h1 className="font-display text-4xl">Alla bolag och innovationer</h1>
        <p className="text-muted-foreground mt-2 max-w-2xl">
          {BOLAG.length} bolag och idéer i Inkuberas portfölj — sorterat efter fas.
        </p>
      </section>

      <section className="px-8 py-8 space-y-10">
        {grupper.map(({ fas, bolag }) => (
          <div key={fas}>
            <div className="flex items-center gap-3 mb-4">
              <h2 className="font-display text-2xl">{fas}</h2>
              <span className="text-sm text-muted-foreground">{bolag.length} st</span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {bolag.map((b) => (
                <Link
                  to="/bolag/$id"
                  params={{ id: b.id }}
                  key={b.id}
                  className="group p-5 rounded-2xl border border-border bg-card hover:border-foreground/40 hover:shadow-md transition-all"
                >
                  <div className="flex items-start gap-3">
                    <CompanyAvatar initialer={b.initialer} farg={b.logoFarg} size={44} />
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center justify-between gap-2">
                        <h3 className="font-display text-lg leading-tight truncate group-hover:underline">
                          {b.namn}
                        </h3>
                        <StatusBadge fas={b.fas} />
                      </div>
                      <div className="flex flex-wrap gap-1 mt-1.5">
                        {b.branscher.map((br) => (
                          <span
                            key={br}
                            className="text-[11px] px-2 py-0.5 rounded-full bg-secondary text-secondary-foreground"
                          >
                            {br}
                          </span>
                        ))}
                      </div>
                      <p className="text-sm text-muted-foreground mt-3 leading-relaxed">
                        {b.beskrivning}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </section>
    </AppShell>
  );
}
